import { useState } from "react";
import { createAgent } from "../api/agentApi";
import { useNavigate } from "react-router-dom";
import { useUser } from "./UserContext";
import { Box, Button, TextField, Typography, Alert, Paper } from "@mui/material";

export default function NewAgentPage() {
  const [json, setJson] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { user } = useUser();

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const agentCard = JSON.parse(json);
      // Inject owner from logged-in user
      agentCard.owner = user?.username || "Unknown";
      const res = await createAgent(agentCard);
      if (res.status === "success") {
        navigate(`/agent/${agentCard.name.toLowerCase().replace(/ /g, "_")}`);
      } else {
        setError("Failed to create agent");
      }
    } catch (err) {
      setError("Invalid JSON");
    }
  };

  return (
    <Box component={Paper} elevation={3} sx={{ maxWidth: 700, mx: "auto", my: 8, p: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>Create New Agent</Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Agent Card JSON"
          value={json}
          onChange={e => setJson(e.target.value)}
          fullWidth
          multiline
          minRows={12}
          margin="normal"
          placeholder="Paste agent card JSON here"
        />
        <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
          Create Agent
        </Button>
      </form>
      {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
    </Box>
  );
}